import React, { Component } from 'react';

import './Table.css';
import TableCheckbox from './TableCheckbox';

class TableRow extends Component {

  handleOnRowSelect = (checked) => {
    const { data, onRowSelection } = this.props;

    onRowSelection(data, checked ? 'select' : 'invert');
  }

  renderRow = (column, index) => {
    const { data } = this.props;
    const { className = '', align = 'left' } = column;

    const classNames = `text-${align} ${className}`;

    const render = column.render || null;
    const idx = `row-${this.props.index}-${index}`;

    return (
      <td key={ idx }
        className={ classNames }
      >
        { render ? render(data) : data[column.dataIndex] }
      </td>
    )
  }

  handleCheckboxCellClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  }

  handleRowClick = () => {
    const { data } = this.props;

    this.props.onRowClick(data);
  }

  render() {
    const { rowSelection, columns, selected, className = '', onRowClick = null, onRowSelection, ...rest } = this.props;

    return (
      <tr
        className={ !!onRowClick ? `it-clickable-row ${className}` : ''}
        onClick={ !!onRowClick ? this.handleRowClick : null }
        { ...rest }
      >
        { !!rowSelection && (
            <td className="fa-table-check-box-cell"
              onClick={ !!onRowClick ? this.handleCheckboxCellClick : null }
            >
              <TableCheckbox checked={ selected } onChange={ this.handleOnRowSelect } />
            </td>
          )
        }
        { columns.map(this.renderRow) }
      </tr>
    )
  }
}

export default TableRow;